
import objectFitImages from 'object-fit-images';
import Components from "./components";
import EventBus from './utils/event-bus';
import * as scrll from './funcs.js';
import 'lazysizes';
import inView from 'in-view';

import * as Sentry from "@sentry/vue";

if (process.env.ENVIRONMENT !== 'dev') {
  Sentry.init({
    app,
    dsn: "https://53e1e990de834a948327a182f9ef70bb@o420960.ingest.sentry.io/6541531",
    environment: process.env.ENVIRONMENT
    // integrations: [
    //   new BrowserTracing({
    //     routingInstrumentation: Sentry.vueRouterInstrumentation(router),
    //     tracingOrigins: ["localhost", "my-site-url.com", /^\//],
    //   }),
    // ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    // tracesSampleRate: 1.0,
  });
}

import './header';
import './notices';
import './forms';
import './sale-banner';
import './pinch-zoom';
import './parallax';
import './slider';
import './swiper';
import './menu';
import './reviews';
import './animations';
import './expander-items';
import Flickity from 'flickity';
// import {FlickityResponsive} from "flickity-responsive";

document.querySelectorAll('.swatches-row').forEach(el => {
  var flkty = new Flickity( el, {
    wrapAround: true,
    pageDots: false,
    watchCSS: true,
    on: {
      ready: function() {
        // console.log('Flickity ready');
        // console.log(el);
      }
    }
  });
});


//* vue =================================================== */

import { createApp } from 'vue/dist/vue.esm-bundler';
import { createPinia } from "pinia";
import Lightbox from "./components/builder/Lightbox.vue";
import Builder from "./components/builder/Builder.vue";
import Overview from "./components/builder/Overview.vue";
import Summary from "./components/builder/Summary.vue";
import Features from "./components/builder/Features.vue";
import FeaturesFilter from "./components/builder/FeaturesFilter.vue";
import Plan from "./components/builder/Plan.vue";
import PlanSelector from "./components/builder/PlanSelector.vue";
import Bar from "./components/builder/Bar.vue";
import Selector from "./components/builder/Selector.vue";
import Input from "./components/builder/Input.vue";
import TextInput from "./components/builder/TextInput.vue";
import SelectInput from "./components/builder/SelectInput.vue";
import TextArea from "./components/builder/TextArea.vue";
import Form from "./components/builder/Form.vue";
import QuoteDisplay from "./components/builder/QuoteDisplay.vue";
import QuoteWall from "./components/builder/QuoteWall.vue";
import Prepare from "./components/builder/Prepare.vue";
import Tile from "./components/builder/Tile.vue";
import UploadImage from "./components/builder/UploadImage.vue";

const app = createApp({
  delimiters: ["${", "}"],
  data() {
    return {
    }
  }
})

app.component('Lightbox', Lightbox);
app.component('Builder', Builder);
app.component('Overview', Overview);
app.component('Summary', Summary);
app.component('Features', Features);
app.component('FeaturesFilter', FeaturesFilter);
app.component('Plan', Plan);
app.component('PlanSelector', PlanSelector);
app.component('Bar', Bar);
app.component('Selector', Selector);
app.component('Input', Input);
app.component('TextInput', TextInput);
app.component('SelectInput', SelectInput);
app.component('TextArea', TextArea);
app.component('BuilderForm', Form);
app.component('QuoteDisplay', QuoteDisplay);
app.component('QuoteWall',  QuoteWall);
app.component('Prepare', Prepare);
app.component('Tile', Tile);
app.component('UploadImage', UploadImage);
app.config.globalProperties.window = window
app.use(createPinia());
app.mount('#app');

//* sticky nav =================================================== */

window.onscroll = function(ev) {

  if ((window.scrollY) > 30) {
    document.body.classList.add('s_sticky');
  } else {
    document.body.classList.remove('s_sticky');
  }

};


//* objectfit polyfill =================================================== */

objectFitImages();


//* is touch device =================================================== */

var isTouch = false;
if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
  isTouch = true;
}


//* navigation =================================================== */

var navOn = 0;
function navToggle() {
  if (navOn) {
    document.body.classList.add('s_nav');
  } else {
    document.body.classList.remove('s_nav');
  }
  if (document.querySelector('.mobnav-link')) {
    document.querySelector('.mobnav-link').setAttribute('tabindex', navOn ? '0' : '-1');
  }
}


document.querySelectorAll('.navtoggle').forEach(el => {
  el.addEventListener('click', e => {
    navOn = !navOn;
    navToggle();
  })
});

document.addEventListener('DOMContentLoaded', () => {
  navToggle();
});



//* animate =================================================== */

inView('.s_animate').on('enter', el => {
  el.classList.remove('s_animate');
});


